import { onDocumentReady as t } from "./document-ready.js";
import { focusableSelector as f } from "./focus-management.js";
let r = [];
t(() => {
  function e(t2) {
    if (!(t2.target instanceof HTMLElement) || t2.target === document.body || r[0] === t2.target) return;
    let n = t2.target;
    n = n.closest(f), r.unshift(n != null ? n : t2.target), r = r.filter((o) => o != null && o.isConnected), r.splice(10);
  }
  window.addEventListener("click", e, { capture: true }), window.addEventListener("mousedown", e, { capture: true }), window.addEventListener("focus", e, { capture: true }), document.body.addEventListener("click", e, { capture: true }), document.body.addEventListener("mousedown", e, { capture: true }), document.body.addEventListener("focus", e, { capture: true });
});
export {
  r as history
};
